export default [
  { label: 'Deportes', value: 'sport' },
  { label: 'Educación', value: 'education' },
  { label: 'Empresa', value: 'company' },
  { label: 'Entretenimiento', value: 'entertainment' },
  { label: 'Gastronomía', value: 'gastronomy' },
  { label: 'Salud', value: 'health' },
  { label: 'Seguros', value: 'insurance' },
  { label: 'Servicios', value: 'services' },
  { label: 'Otros', value: 'others' }
];
